/*
  Kiwi Ears · awards press row (Rene 2026-08-31) — sections/aw-press.

  Replaces the Flickity carousel with a native scroll-snap track: the
  browser owns the physics, this file only wires the header arrows, the
  poster fallback and the inline playback. Videos play IN the card, never
  in a modal (Rene's rule) — the embed/coverSize logic carries over from
  the first build unchanged.
*/
(function () {
  'use strict';
  if (window.__awPressReady) return;
  window.__awPressReady = true;

  function embed(url) {
    var m;
    if ((m = url.match(/(?:youtube\.com\/.*[?&]v=|youtube\.com\/shorts\/|youtu\.be\/)([\w-]{6,})/)))
      return { kind: 'iframe', src: 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&rel=0&playsinline=1' };
    if ((m = url.match(/vimeo\.com\/(\d+)/)))
      return { kind: 'iframe', src: 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1' };
    if (url) return { kind: 'mp4', src: url };
    return null;
  }
  function coverSize(el, box) {
    var w = box.clientWidth, h = box.clientHeight, ar = 16 / 9, iw, ih;
    if (w / h > ar) { iw = w; ih = w / ar; } else { ih = h; iw = h * ar; }
    el.style.position = 'absolute'; el.style.width = iw + 'px'; el.style.height = ih + 'px';
    el.style.left = ((w - iw) / 2) + 'px'; el.style.top = ((h - ih) / 2) + 'px';
  }

  function arm() {
    var root = document.querySelector('[data-awpress]');
    var row = document.getElementById('aw-press-row');
    if (!root || !row) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* header arrows — shown only when the track actually overflows */
    var nav = root.querySelector('[data-awpress-nav]');
    var prev = root.querySelector('[data-awpress-prev]');
    var next = root.querySelector('[data-awpress-next]');
    function step() {
      var card = row.firstElementChild;
      return card ? card.getBoundingClientRect().width + 20 : row.clientWidth * 0.8;
    }
    function syncNav() {
      if (!nav) return;
      var overflows = row.scrollWidth > row.clientWidth + 4;
      nav.hidden = !overflows;
      if (!overflows) return;
      if (prev) prev.disabled = row.scrollLeft <= 4;
      if (next) next.disabled = row.scrollLeft >= row.scrollWidth - row.clientWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () {
      row.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      row.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' });
    });
    row.addEventListener('scroll', function () { window.requestAnimationFrame(syncNav); }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(syncNav).observe(row);
    syncNav();

    /* maxres posters 404 on many shorts — fall back to hq */
    row.querySelectorAll('img[data-yid]').forEach(function (im) {
      im.addEventListener('error', function once() {
        im.removeEventListener('error', once);
        im.src = 'https://i.ytimg.com/vi/' + im.getAttribute('data-yid') + '/hqdefault.jpg';
      });
    });

    /* inline playback inside the card — no modal (Rene's rule) */
    row.addEventListener('click', function (ev) {
      var pill = ev.target.closest('.pk-revplay');
      if (!pill || !row.contains(pill)) return;
      var card = pill.closest('[data-video]');
      if (!card) return;
      var v = embed(card.getAttribute('data-video') || '');
      if (!v) return;
      var stage = document.createElement('div');
      stage.className = 'pk-revstage';
      stage.style.cssText = 'position:absolute;inset:0;overflow:hidden;background:#000;opacity:0;transition:opacity .4s';
      var el;
      if (v.kind === 'iframe') {
        el = document.createElement('iframe');
        el.src = v.src; el.title = 'Review video'; el.frameBorder = '0';
        el.allow = 'autoplay; encrypted-media; picture-in-picture'; el.allowFullscreen = true;
        coverSize(el, card);
        var onResize = function () { if (stage.parentNode) coverSize(el, card); else window.removeEventListener('resize', onResize); };
        window.addEventListener('resize', onResize);
      } else {
        el = document.createElement('video');
        el.src = v.src; el.autoplay = true; el.playsInline = true; el.setAttribute('playsinline', ''); el.controls = true;
        el.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover';
      }
      stage.appendChild(el);
      var x = document.createElement('button');
      x.type = 'button'; x.setAttribute('aria-label', 'Close video');
      x.textContent = '✕';
      x.style.cssText = 'position:absolute;top:12px;right:12px;z-index:2;width:34px;height:34px;border-radius:50%;border:1px solid rgba(255,255,255,.25);background:rgba(0,0,0,.45);color:#fff;font-size:14px;cursor:pointer';
      x.addEventListener('click', function () { stage.style.opacity = '0'; setTimeout(function () { stage.remove(); card.classList.remove('is-playing'); }, 420); });
      stage.appendChild(x);
      card.appendChild(stage);
      card.classList.add('is-playing');
      requestAnimationFrame(function () { stage.style.opacity = '1'; });
    });

    if (window.gsap && window.ScrollTrigger && !reduce) {
      var mm = window.gsap.matchMedia();
      mm.add('(prefers-reduced-motion: no-preference)', function () {
        window.gsap.from('#aw-press-head > *', { y: 24, opacity: 0, duration: 0.6, stagger: 0.1, ease: 'power3.out', scrollTrigger: { trigger: '#aw-press-head', start: 'top 82%', once: true } });
        window.gsap.from('#aw-press-row', { y: 30, opacity: 0, duration: 0.7, ease: 'power3.out', scrollTrigger: { trigger: '#aw-press-row', start: 'top 85%', once: true } });
      });
    }
  }
  if (document.readyState === 'complete') { arm(); } else { window.addEventListener('load', arm); }
})();
